import './style.scss';
import Pretitle from './pretitle.js';

export default Pretitle;